export enum InvoiceStatus {
  OUTSTANDING = 'OUTSTANDING',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE'
}
